import React from "react";
import { useRoutes, Navigate } from "react-router-dom";

import Login from "@pages/admin/auth/login";
import AdminLayout from "@components/layout/admin/layout";

import BannerSetup from "@pages/admin/setup/banner/bannerSetup";
import BannerForm from "@pages/admin/setup/banner/bannerForm";

import BankSetup from "@pages/admin/setup/bank/bankSetup";
import BankForm from "@pages/admin/setup/bank/bankForm";

import FundSetup from "@pages/admin/setup/fund/fundSetup";
import FundForm from "@pages/admin/setup/fund/fundForm";

import QuestionSetup from "@pages/admin/setup/question/questionSetup";
import QuestionForm from "@pages/admin/setup/question/questionForm";

import FormSetup from "@pages/admin/setup/form/formSetup";
import FormForm from "@pages/admin/setup/form/formForm/formForm";

import Post from "@pages/admin/post/post";
import PostForm from "@pages/admin/post/postForm";

import Application from "@pages/admin/application/application";
import ApplicationForm from "@pages/admin/application/applicationForm/applicationForm";

import ActivityPayment from "@pages/admin/payment/activity/activityPayment";
import ActivityPaymentForm from "@pages/admin/payment/activity/activityPaymentForm";

import DonationPayment from "@pages/admin/payment/donation/donationPayment";
import DonationPaymentForm from "@pages/admin/payment/donation/donationPaymentForm";

import FeaturedPayment from "@pages/admin/payment/featured/featuredPayment";
import FeaturedPaymentForm from "@pages/admin/payment/featured/featuredPaymentForm";

import Broadcast from "@pages/admin/broadcast/broadcast";
import NewsletterForm from "@pages/admin/broadcast/newsletter/newsletterForm";
import SubscriberForm from "@pages/admin/broadcast/subscriber/subscriberForm";

import Security from "@pages/admin/security/security";
import RoleForm from "@pages/admin/security/role/roleForm/roleForm";
import UserForm from "@pages/admin/security/user/userForm";

import Inquiry from "@pages/admin/inquiry/inquiry";
import InquiryForm from "@pages/admin/inquiry/inquiryForm";

import Section1Form from "@pages/admin/aboutUs/section1Form";
import Section2Form from "@pages/admin/aboutUs/section2Form";
import Section3Form from "@pages/admin/aboutUs/section3From";
import Section4Form from "@pages/admin/aboutUs/section4Form";

import Dashboard from "@pages/admin/dashboard/dashboard";

import UserLayout from "@components/layout/user/layout";

import Home from "@pages/user/home/home";
import AboutUs from "@pages/user/aboutUs/aboutUs";
import Activity from "@pages/user/activity/activity";
import ActivityPost from "@pages/user/activity/post/post";
import ActivityApplication from "@pages/user/activity/application/application";
import Payment from "@pages/user/payment/payment";
import PaymentStatus from "@pages/user/payment/status/status";
import SupportUs from "@pages/user/supportUs/supportUs";
import ContactUs from "@pages/user/contactUs/contactUs";
import Unsubscribe from "@pages/user/unsubscribe/unsubscribe";
import Featured from "@pages/user/featured/featured";
import FeaturedRequest from "@pages/user/featured/request/featuredRequest";

import Blog from "@pages/user/blog/blog";
import BlogPost from "@pages/user/blog/post/blogPost";

import FeaturedAdmin from "@pages/admin/featured/featured";
import FeaturedAdminForm from "@pages/admin/featured/featuredForm";

import BlogAdmin from "@pages/admin/blog/blog";
import BlogAdminForm from "@pages/admin/blog/blogForm";

import AdminNotFoundPage from "@pages/admin/error/notFoundPage";
import UserNotFoundPage from "@pages/user/error/notFoundPage";

import ProtectedModuleRoute from "@components/auth/protectedModuleRoute";

import { MODULE_GUID } from "@utils/constant";
import ServerMaintenance from "@pages/user/misc/serverMaintenance";

export const routes = [
  /*{
    // path: "*",
    // element: <ServerMaintenance />,
  }*/
  {
    path: "",
    element: <UserLayout />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "about-us",
        element: <AboutUs />,
      },
      {
        path: "activity",
        element: <Activity />,
      },
      {
        path: "activity/:id",
        element: <ActivityPost />,
      },
      {
        path: "activity/register/:id",
        element: <ActivityApplication />,
      },
      {
        path: "payment",
        element: <Payment />,
      },
      {
        path: "payment/application/:id",
        element: <Payment />,
      },
      {
        path: "payment/status/application/:id",
        element: <PaymentStatus />,
      },
      {
        path: "payment/status/application",
        element: <PaymentStatus />,
      },
      {
        path: "payment/status/donation",
        element: <PaymentStatus />,
      },
      {
        path: "support-us",
        element: <SupportUs />,
      },
      {
        path: "contact-us",
        element: <ContactUs />,
      },
      {
        path: "unsubscribe",
        element: <Unsubscribe />,
      },
      {
        path: "featured",
        element: <Featured />,
      },
      {
        path: "featured/:id",
        element: <FeaturedRequest />,
      },
      // {
      //   path: "blog",
      //   element: <Blog />,
      // },
      // {
      //   path: "blog/:id",
      //   element: <BlogPost />,
      // },
      {
        path: "*",
        element: <UserNotFoundPage />,
      },
    ]
  },
  {
    path: "admin",
    children: [
      {
        path: "login",
        element: <Login />,
      },
      {
        element: <AdminLayout />,
        children: [
          {
            path: "",
            element: <Dashboard />,
          },
          {
            path: "post",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.POST} />,
            children: [
              {
                title: "Post",
                path: "",
                element: <Post />,
                sideNav: { module: "Post" },
              },
              {
                title: "View Post",
                path: "view",
                element: <PostForm />,
              },
              {
                element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.POST} isAdminOnly />,
                children: [
                  {
                    title: "Create Post",
                    path: "create",
                    element: <PostForm />,
                  },
                  {
                    title: "Edit Post",
                    path: "edit",
                    element: <PostForm />,
                  },
                ],
              },
            ],
          },
          {
            path: "applications",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.APPLICATION} />,
            children: [
              {
                title: "Applications",
                path: "",
                element: <Application />,
                sideNav: { module: "Applications" },
              },
              {
                title: "View Application",
                path: "view",
                element: <ApplicationForm />,
              },
            ],
          },
          {
            path: "featured",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.POST} />,
            children: [
              {
                title: "Featured",
                path: "",
                element: <FeaturedAdmin />,
                sideNav: { module: "Featured Donation" },
              },
              {
                title: "View Featured",
                path: "view",
                element: <FeaturedAdminForm />,
              },
              {
                title: "Create Featured",
                path: "create",
                element: <FeaturedAdminForm />,
              },
              {
                title: "Edit Featured",
                path: "edit",
                element: <FeaturedAdminForm />,
              },
            ],
          },
          // {
          //   path: "blog",
          //   element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.POST} />,
          //   children: [
          //     {
          //       title: "Blog",
          //       path: "",
          //       element: <BlogAdmin />,
          //       sideNav: { module: "Blog" },
          //     },
          //     {
          //       title: "View Blog",
          //       path: "view",
          //       element: <BlogAdminForm />,
          //     },
          //     {
          //       title: "Create Blog",
          //       path: "create",
          //       element: <BlogAdminForm />,
          //     },
          //     {
          //       title: "Edit Blog",
          //       path: "edit",
          //       element: <BlogAdminForm />,
          //     },
          //   ],
          // },
          {
            path: "activity-payment",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.PAYMENT} />,
            children: [
              {
                title: "Activity Payment",
                path: "",
                element: <ActivityPayment />,
                sideNav: { module: "Activity Payment" },
              },
              {
                title: "View Activity Payment",
                path: "view",
                element: <ActivityPaymentForm />,
              },
              {
                element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.PAYMENT} isAdminOnly />,
                children: [
                  {
                    title: "Create Activity Payment",
                    path: "create",
                    element: <ActivityPaymentForm />,
                  },
                ],
              },
            ],
          },
          {
            path: "donation-payment",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.PAYMENT} />,
            children: [
              {
                title: "Donation Payment",
                path: "",
                element: <DonationPayment />,
                sideNav: { module: "Donation Payment" },
              },
              {
                title: "View Donation Payment",
                path: "view",
                element: <DonationPaymentForm />,
              },
              {
                element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.PAYMENT} isAdminOnly />,
                children: [
                  {
                    title: "Create Donation Payment",
                    path: "create",
                    element: <DonationPaymentForm />,
                  },
                ],
              },
            ],
          },
          {
            path: "featured-donation",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.PAYMENT} />,
            children: [
              {
                title: "Featured Donation",
                path: "",
                element: <FeaturedPayment />,
                sideNav: { module: "Featured Donation" },
              },
              {
                title: "View Featured Donation",
                path: "view",
                element: <FeaturedPaymentForm />,
              },
            ],
          },
          {
            path: "broadcasts",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.BROADCAST} />,
            children: [
              {
                title: "Broadcasts",
                path: "",
                element: <Broadcast />,
                sideNav: { module: "Broadcasts" },
              },
              {
                title: "View Broadcast",
                path: "view",
                element: <NewsletterForm />,
              },
              {
                title: "Create Broadcast",
                path: "create",
                element: <NewsletterForm />,
              },
              {
                title: "Edit Broadcast",
                path: "edit",
                element: <NewsletterForm />,
              },
              {
                title: "View Subscriber",
                path: "view-subscriber",
                element: <SubscriberForm />
              },
              {
                title: "Create Subscriber",
                path: "create-subscriber",
                element: <SubscriberForm />
              },
              {
                title: "Edit Subscriber",
                path: "edit-subscriber",
                element: <SubscriberForm />
              }
            ],
          },
          {
            path: "security",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.SECURITY} />,
            children: [
              {
                title: "Security",
                path: "",
                element: <Security />,
                sideNav: { module: "Security" },
              },
              {
                title: "View Role",
                path: "view-role",
                element: <RoleForm />,
              },
              {
                title: "Create Role",
                path: "create-role",
                element: <RoleForm />,
              },
              {
                title: "Edit Role",
                path: "edit-role",
                element: <RoleForm />,
              },
              {
                title: "View User",
                path: "view-user",
                element: <UserForm />,
              },
              {
                title: "Create User",
                path: "create-user",
                element: <UserForm />,
              },
              {
                title: "Edit User",
                path: "edit-user",
                element: <UserForm />,
              },
            ],
          },
          {
            path: "inquiries",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.INQUIRY} />,
            children: [
              {
                title: "Inquiries",
                path: "",
                element: <Inquiry />,
                sideNav: { module: "Inquiries" },
              },
              {
                title: "View Inquiry",
                path: "view",
                element: <InquiryForm />,
              }
            ],
          },
          {
            path: "banner-setup",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.SETUP} />,
            children: [
              {
                title: "Banner Setup",
                path: "",
                element: <BannerSetup />,
                sideNav: { module: "Banner Setup" },
              },
              {
                title: "View Banner",
                path: "view",
                element: <BannerForm />,
              },
              {
                title: "Create Banner",
                path: "create",
                element: <BannerForm />,
              },
              {
                title: "Edit Banner",
                path: "edit",
                element: <BannerForm />,
              },
            ],
          },
          {
            path: "bank-setup",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.SETUP} />,
            children: [
              {
                title: "Bank Setup",
                path: "",
                element: <BankSetup />,
                sideNav: { module: "Bank Setup" },
              },
              {
                title: "View Bank",
                path: "view",
                element: <BankForm />,
              },
              {
                title: "Create Bank",
                path: "create",
                element: <BankForm />,
              },
              {
                title: "Edit Bank",
                path: "edit",
                element: <BankForm />,
              },
            ],
          },
          {
            path: "fund-setup",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.SETUP} />,
            children: [
              {
                title: "Fund Setup",
                path: "",
                element: <FundSetup />,
                sideNav: { module: "Fund Setup" },
              },
              {
                title: "View Fund",
                path: "view",
                element: <FundForm />,
              },
              {
                title: "Create Fund",
                path: "create",
                element: <FundForm />,
              },
              {
                title: "Edit Fund",
                path: "edit",
                element: <FundForm />,
              },
            ],
          },
          {
            path: "question-setup",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.SETUP} />,
            children: [
              {
                title: "Question Setup",
                path: "",
                element: <QuestionSetup />,
                sideNav: { module: "Question Setup" },
              },
              {
                title: "View Question",
                path: "view",
                element: <QuestionForm />,
              },
              {
                title: "Create Question",
                path: "create",
                element: <QuestionForm />,
              },
              {
                title: "Edit Question",
                path: "edit",
                element: <QuestionForm />,
              },
            ],
          },
          {
            path: "form-setup",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.SETUP} />,
            children: [
              {
                title: "Form Setup",
                path: "",
                element: <FormSetup />,
                sideNav: { module: "Form Setup" },
              },
              {
                title: "View Form",
                path: "view",
                element: <FormForm />,
              },
              {
                title: "Create Form",
                path: "create",
                element: <FormForm />,
              },
              {
                title: "Edit Form",
                path: "edit",
                element: <FormForm />,
              },
            ],
          },
          {
            path: "section-1",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.ABOUT_US} />,
            children: [
              {
                title: "Section 1",
                path: "",
                element: <Section1Form />,
                sideNav: { module: "Section 1" },
              },
            ],
          },
          {
            path: "section-2",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.ABOUT_US} />,
            children: [
              {
                title: "Section 2",
                path: "",
                element: <Section2Form />,
                sideNav: { module: "Section 2" },
              },
            ],
          },
          {
            path: "section-3",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.ABOUT_US} />,
            children: [
              {
                title: "Section 3",
                path: "",
                element: <Section3Form />,
                sideNav: { module: "Section 3" },
              },
            ],
          },
          {
            path: "section-4",
            element: <ProtectedModuleRoute moduleGuid={MODULE_GUID.ABOUT_US} />,
            children: [
              {
                title: "Section 4",
                path: "",
                element: <Section4Form />,
                sideNav: { module: "Section 4" },
              },
            ],
          },
          {
            path: "*",
            element: <AdminNotFoundPage />,
          }
        ]
      },
    ],
  }
];

export default function Routes() {
  return <>{useRoutes(routes)}</>;
}